import React, { useState } from 'react';
import { TiArrowBack } from "react-icons/ti";
import './StoreDetail.css';

const StoreDetail = ({ store, onBack }) => {
  const [view, setView] = useState('info'); // 'info', 'map'

  return (
    <div className="store-detail">
      <div className="detail-header">
        <button className="back-btn" onClick={onBack}><TiArrowBack /></button>
        <h2>{store.name}</h2>        
      </div>
            <div className="store-hero" style={{ backgroundImage: `url(${store.image})` }} />

      {/*<img src={store.image} alt={store.name} className="store-image" />*/}

      {view === 'info' ? (
        <div className="store-info-detail">
          {store.name === 'Caballito' && (
            <div className="store-tags">
              <span className="tag">Cafe Instagram</span>
              <span className="tag">X=presso</span>
            </div>
          )}
          
          <div className="store-description">
            <p>{store.description}</p>
          </div>

          <div className="store-features">
            <h4>Características:</h4>
            <div className="features-list">
              {store.features.map((feature, index) => (
                <span key={index} className="feature-tag">{feature}</span>
              ))}
            </div>
          </div>

          <div className="store-address-detail">
            <h4>Dirección:</h4>
            <p>{store.address}</p>
          </div>

          <div className="store-hours-detail">
            <h4>Horarios:</h4>
            {store.hours.split('\n').map((line, index) => (
              <p key={index}>{line}</p>
            ))}
          </div>

          <button 
            className="view-map-btn"
            onClick={() => setView('map')}
          >
            Ver en Mapa
          </button>
        </div>
      ) : (
        <div className="store-map-detail">
          <div className="map-placeholder">
            {/* En una app real, aquí iría un mapa interactivo */}
            <div className="simplified-store-map">
              <div className="map-marker">
                📍
              </div>
              <div className="store-location">
                <h4>{store.name}</h4>
                <p>{store.address}</p>
              </div>
            </div>
          </div>
          
          <div className="map-instructions">
            <p>Sigue la ruta en el mapa.</p>
          </div>

          <div className="map-actions">
            <button className="back-to-store-btn" onClick={() => setView('info')}>
              Atras a Tiendas
            </button>
            <button className="navigate-btn">
              Abrir en mapa
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default StoreDetail;